import { createContext, useContext, useState } from "react";

const PreviewContext = createContext<any>({});
export const PreviewProvider = ({ children }) => {
    const [type, setType] = useState(0);

    return (
        <PreviewContext.Provider value={{ type, setType }}>
            {children}
        </PreviewContext.Provider>
    )
}
const usePreviewProvider = () => useContext(PreviewContext);

export default usePreviewProvider;